import React, { useContext } from "react";
import moment from "moment";
import { formatPrice, getSystemSettings, formatReportDate } from "../../../../functions/Functions";
import { SettingsContext } from "../../../../contexts/Settings";

const PosSessionActivityReport = (props) => {
  const { reportData, componentRefPosSession } = props;
  const { generalSettings } = useContext(SettingsContext);
  console.log("PosSessionActivityReport", reportData);

  if (!reportData) return null;

  return (
    <div className="d-none">
      <div ref={componentRefPosSession} className="fk-print-text_pos new-xsm-text text-capitalize" style={{ wordBreak: "break-word" }}>
        {/* Header section */}
        <div className="text-center mb-3">
          <p className="font-weight-bold xslg-text border-bottom border-top border-dark py-1 m-0">
            {reportData.header?.report_name || 'POS Session Activity Report'}
          </p>
        </div>

        {/* Info Table */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border border-dark border-bottom-0 text-center font-weight-bold py-1">
            {reportData.header?.company_name || getSystemSettings(generalSettings, "siteName")}
          </p>
          <p className="mb-0 border border-dark border-bottom-0 text-center font-weight-bold py-1">
            Counter : {reportData.header?.counter_name || reportData.header?.branch_name || "Branch Name"}
          </p>
          <p className="mb-0 border border-dark border-bottom-0 text-center font-weight-bold py-1">
            Shift : {reportData.header?.shift_name || "Branch Wise"}
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-bottom-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Opening Date</span>
            <span className="text-right px-1 py-1" style={{ width: "50%" }}>{reportData.header?.opening_date ? formatReportDate(reportData.header?.opening_date) : "-"}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-bottom-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Closing Date</span>
            <span className="text-right px-1 py-1" style={{ width: "50%" }}>{reportData.header?.closing_date ? formatReportDate(reportData.header?.closing_date) : "-"}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-bottom-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Printed Date</span>
            <span className="text-right px-1 py-1" style={{ width: "50%" }}>{moment().format("DD-MM-YYYY, dddd, h:mm a")}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-bottom-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Session Open Operator</span>
            <span className="text-right px-1 py-1" style={{ width: "50%" }}>{reportData.header?.session_open_operator || "-"}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Session Closing Operator</span>
            <span className="text-right px-1 py-1" style={{ width: "50%" }}>{reportData.header?.session_closing_operator || "-"}</span>
          </p>
        </div>

        {/* Sale Summary */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border fk-print-text_pos border-dark text-center font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            Sale Summary
          </p>
          <p className="mb-0 d-flex w-100 fk-print-text_pos border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "35%" }}>Document Type</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "20%" }}>No Of Doc.</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "25%" }}>Amount</span>
            <span className="font-weight-bold px-1 py-1 text-right" style={{ width: "20%" }}>Dis.</span>
          </p>
          {Array.isArray(reportData?.sale_summary) && reportData.sale_summary.map((item, index) => {
            const isBold = item.doc_type === "Net Amount" || item.doc_type === "Sale Invoice";
            return (
              <p key={index} className={`mb-0 d-flex fk-print-text_pos w-100 border border-dark border-top-0 ${isBold ? 'font-weight-bold' : ''}`}>
                <span className="border-right border-dark px-1 py-1" style={{ width: "35%" }}>{item.doc_type}</span>
                <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "20%" }}>{item.no_of_docs}</span>
                <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "25%" }}>{formatPrice(item.amount)}</span>
                <span className="px-1 py-1 text-right" style={{ width: "20%" }}>{formatPrice(item.discount)}</span>
              </p>
            );
          })}
        </div>

        {/* Cash Received Summary */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border fk-print-text_pos border-dark text-center fk-print-text_pos font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            Cash Received Summary
          </p>
          <p className="mb-0 d-flex fk-print-text_pos w-100 border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "60%" }}>Opening Amount</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{reportData?.cash_received_summary?.opening_amount ? formatPrice(reportData.cash_received_summary.opening_amount) : "-"}</span>
          </p>
          <p className="mb-0 d-flex fk-print-text_pos w-100 border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "60%" }}>Cash Sales</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{reportData?.cash_received_summary?.sale_cash ? formatPrice(reportData.cash_received_summary.sale_cash) : "-"}</span>
          </p>
          <p className="mb-0 d-flex fk-print-text_pos w-100 border border-dark border-top-0 font-weight-bold">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Total Amount</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{reportData?.cash_received_summary?.total_amount ? formatPrice(reportData.cash_received_summary.total_amount) : "-"}</span>
          </p>
        </div>

        {/* Cash Paid Summary */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border border-dark text-center fk-print-text_pos font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            Cash Paid Summary
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "60%" }}>Details</span>
            <span className="font-weight-bold px-1 py-1 text-right" style={{ width: "40%" }}>Amount</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Cash Back / Sale Return</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.cash_paid_summary?.cash_back_sale_return ?? 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Payment Voucher Expense</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.cash_paid_summary?.payment_voucher_expense ?? 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0 font-weight-bold">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Total Amount</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.cash_paid_summary?.total_amount ?? 0)}</span>
          </p>
        </div>

        {/* Tax & Charges Summary */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border border-dark text-center fk-print-text_pos font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            Tax & Charges Summary
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "60%" }}>Description</span>
            <span className="font-weight-bold px-1 py-1 text-right" style={{ width: "40%" }}>Amount</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>GST</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.tax_and_charges_summary?.gst || 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Delivery Charges</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.tax_and_charges_summary?.delivery_charges || 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0 font-weight-bold">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Total</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.tax_and_charges_summary?.total || 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Sales Tax - Cash</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.tax_and_charges_summary?.sales_tax_cash || 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Sales Tax - Card</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.tax_and_charges_summary?.sales_tax_card || 0)}</span>
          </p>
        </div>

        {/* Currency Denominations */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border border-dark text-center fk-print-text_pos font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            Currency Denominations
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "50%" }}>Name</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "25%" }}>Quantity</span>
            <span className="font-weight-bold px-1 py-1 text-right" style={{ width: "25%" }}>Amount</span>
          </p>
          {reportData?.currency_denomination?.denominations && Array.isArray(reportData.currency_denomination.denominations) && reportData.currency_denomination.denominations.length > 0 ? (
            <>
              {reportData.currency_denomination.denominations.map((item, index) => {
                return (
                  <p key={index} className="mb-0 d-flex w-100 border border-dark border-top-0">
                    <span className="border-right border-dark px-1 py-1" style={{ width: "50%" }}>{item.name}</span>
                    <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "25%" }}>{item.quantity}</span>
                    <span className="px-1 py-1 text-right" style={{ width: "25%" }}>{formatPrice(item.amount)}</span>
                  </p>
                )
              })}
              <p className="mb-0 d-flex w-100 border border-dark border-top-0 font-weight-bold">
                <span className="border-right border-dark px-1 py-1" style={{ width: "75%" }}>Total Amount</span>
                <span className="px-1 py-1 text-right" style={{ width: "25%" }}>
                  {formatPrice(reportData.currency_denomination.total_amount || 0)}
                </span>
              </p>
              <p className="mb-0 d-flex w-100 border border-dark border-top-0 font-weight-bold">
                <span className="border-right border-dark px-1 py-1" style={{ width: "75%" }}>As Per Software</span>
                <span className="px-1 py-1 text-right" style={{ width: "25%" }}>
                  {formatPrice(reportData.currency_denomination.as_per_software || 0)}
                </span>
              </p>
              <p className="mb-0 d-flex w-100 border border-dark border-top-0 font-weight-bold">
                <span className="border-right border-dark px-1 py-1" style={{ width: "75%" }}>Balanced Amount</span>
                <span className="px-1 py-1 text-right" style={{ width: "25%" }}>
                  {formatPrice(reportData.currency_denomination.balanced_amount || 0)}
                </span>
              </p>
            </>
          ) : (
            <p className="mb-0 border border-dark border-top-0 text-center py-1">No data</p>
          )}
        </div>

        {/* Difference Summary */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border border-dark text-center fk-print-text_pos font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            Difference Summary
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "25%" }}>Mode of Payment</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "20%" }}>Expected</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "20%" }}>Closing</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "20%" }}>Diff</span>
            <span className="font-weight-bold px-1 py-1 text-right" style={{ width: "15%" }}>Status</span>
          </p>
          {Array.isArray(reportData?.difference_summary) && reportData.difference_summary.length > 0 ? (
            reportData.difference_summary.map((item, index) => (
              <p key={`diff-${index}`} className="mb-0 d-flex w-100 border border-dark border-top-0">
                <span className="border-right border-dark px-1 py-1" style={{ width: "25%", wordBreak: "break-word" }}>{item.mode_of_payment}</span>
                <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "20%", wordBreak: "break-word" }}>{formatPrice(item.expected)}</span>
                <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "20%", wordBreak: "break-word" }}>{formatPrice(item.closing)}</span>
                <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "20%", wordBreak: "break-word" }}>{formatPrice(item.diff)}</span>
                <span className="px-1 py-1 text-right" style={{ width: "15%", wordBreak: "break-word" }}>{item.status}</span>
              </p>
            ))
          ) : (
            <p className="mb-0 border border-dark border-top-0 text-center py-1">No data</p>
          )}
        </div>

        {/* Merchant Summary */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-3">
          <p className="mb-0 border border-dark text-center fk-print-text_pos font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            Merchant Summary
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "40%" }}>Merchant Name</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "30%" }}>No Of Doc</span>
            <span className="font-weight-bold px-1 py-1 text-right" style={{ width: "30%" }}>Amount</span>
          </p>
          {Array.isArray(reportData?.merchant_summary) && reportData.merchant_summary.map((item, index) => (
            <p key={`merchant-${index}`} className="mb-0 d-flex w-100 border border-dark border-top-0">
              <span className="border-right border-dark px-1 py-1" style={{ width: "40%" }}>{item.merchant_name}</span>
              <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "30%" }}>{item.no_of_doc}</span>
              <span className="px-1 py-1 text-right" style={{ width: "30%" }}>{formatPrice(item.amount)}</span>
            </p>
          ))}
          {(!Array.isArray(reportData?.merchant_summary) || reportData.merchant_summary.length === 0) && (
            <p className="mb-0 border border-dark border-top-0 text-center py-1">No data</p>
          )}
        </div>

        {/* POS ACTIVITY DETAILS */}
        <div className="new-xsm-text fk-print-text_pos text-capitalize mb-5">
          <p className="mb-0 border border-dark text-center fk-print-text_pos font-weight-bold bg-dark text-white py-1" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
            POS ACTIVITY DETAILS
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark font-weight-bold px-1 py-1" style={{ width: "40%" }}>Payment Voucher Expenses Details</span>
            <span className="border-right border-dark font-weight-bold px-1 py-1 text-center" style={{ width: "30%" }}>Amount</span>
            <span className="font-weight-bold px-1 py-1 text-right" style={{ width: "30%" }}>Voucher Date</span>
          </p>
          {Array.isArray(reportData?.pos_activity_detail?.payment_voucher_expense) && reportData.pos_activity_detail.payment_voucher_expense.length > 0 ? (
            reportData.pos_activity_detail.payment_voucher_expense.map((item, index) => {
              return (
                <p key={`sales-activity-${index}`} className="mb-0 d-flex w-100 border border-dark border-top-0">
                  <span className="border-right border-dark px-1 py-1" style={{ width: "40%" }}>{item.details || item.deposit_details || "-"}</span>
                  <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "30%" }}>{formatPrice(item.amount || 0)}</span>
                  <span className="px-1 py-1 text-right" style={{ width: "30%" }}>{item.voucher_date || item.date || "-"}</span>
                </p>
              )
            })
          ) : (
            <p className="mb-0 d-flex w-100 border border-dark border-top-0">
              <span className="border-right border-dark px-1 py-1" style={{ width: "40%" }}>-</span>
              <span className="border-right border-dark px-1 py-1 text-center" style={{ width: "30%" }}>-</span>
              <span className="px-1 py-1 text-right" style={{ width: "30%" }}>-</span>
            </p>
          )}
          
          <div className="py-2"></div>
          
          <p className="mb-0 d-flex w-100 border border-dark font-weight-bold">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Details</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>Amount</span>
          </p>
          {Array.isArray(reportData?.grand_total?.details) && reportData.grand_total.details.map((item, index) => (
             <p key={`grand-total-detail-${index}`} className="mb-0 d-flex w-100 border border-dark border-top-0">
               <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>{item.type}</span>
               <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(item.amount)}</span>
             </p>
          ))}
          <p className="mb-0 d-flex w-100 border border-dark border-top-0 font-weight-bold">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Total Amount</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.grand_total?.total_amount || 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Total Sale</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.grand_total?.total_sale || 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Total Return</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.grand_total?.total_return || 0)}</span>
          </p>
          <p className="mb-0 d-flex w-100 border border-dark border-top-0 font-weight-bold">
            <span className="border-right border-dark px-1 py-1" style={{ width: "60%" }}>Net Amount</span>
            <span className="px-1 py-1 text-right" style={{ width: "40%" }}>{formatPrice(reportData?.grand_total?.net_amount || 0)}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PosSessionActivityReport;
